import { PlanCart, PlanRuleManager } from "@/common/persist-cart/core";
import { getAllProductInfo } from "@/flows/helper/get-plans-data";
import { plansDataMapper } from "@/common/service/plan-data-mapper";
import { loadValidationRules } from "@/pages/opc-persistent-cart/validation";
import { getBasicConfig$Cache } from "@/common/service/common";
import { keyBy } from "lodash";
import { BASE_PLAN_TYPES, BillingCycleEnum } from "@/common/constants";

function getOptions() {
  return {
    getBasePlan: (cart) => {
      const allPlans = cart.getAllPlans();
      // Iterate through BASE_PLAN_TYPES in order of priority
      for (const type of BASE_PLAN_TYPES) {
        const matchingPlans = allPlans.filter((p) => p.type === type);
        if (matchingPlans.length > 0) {
          // If multiple plans of the same priority type exist, pick the one with the largest billing cycle
          return matchingPlans.reduce((maxPlan, currentPlan) => {
            const currentCycleValue = BillingCycleEnum[currentPlan.billingCycle] || 0;
            const maxCycleValue = BillingCycleEnum[maxPlan.billingCycle] || 0;
            return currentCycleValue > maxCycleValue ? currentPlan : maxPlan;
          });
        }
      }
      return null;
    },
  };
}

async function getPersistCart() {
  preLoadPersistContext();
  const isC50Plan = true,
    hasUnsupportBillingCyclePlan = false,
    hasBoughtUnlimitedAudio = false,
    isCheckFromCampaign = false;
  const getAllProductInfoPromise = (...args) => getAllProductInfo(...args).then(({ planMap }) => planMap);
  const [planMapRes, config] = await Promise.all([
    getAllProductInfoPromise(isC50Plan, hasUnsupportBillingCyclePlan, hasBoughtUnlimitedAudio, isCheckFromCampaign),
    getBasicConfig$Cache(),
  ]);

  let planMapData = plansDataMapper(planMapRes, []);

  const cart = new PlanCart(planMapData, getOptions());
  cart.config = config?.result;
  const ruleManager = new PlanRuleManager();

  // Load validation rules from all validation.js files
  await loadValidationRules(ruleManager, cart);
  ruleManager.applyRulesToCart(cart);
  try {
    await cart.loadData();
  } catch (e) {
    console.error(e);
  }
  return cart;
}

function preLoadPersistContext() {
  window.$context.is.persistCart = true;
  window.campaignFlags = window.campaignFlags ?? {};
  window.campaignFlags.enableHardware4Online = true;
}

export let innerCart;

export async function buildInnerCart(planList) {
  try {
    innerCart = new PlanCart(planList, { autoSave: false, ...getOptions() });
    const ruleManager = new PlanRuleManager();
    // Load validation rules from all validation.js files
    await loadValidationRules(ruleManager, innerCart);
    ruleManager.applyRulesToCart(innerCart);
    const filteredPlans = planList
      .filter((p) => p.cartInfo?.selected_number > 0)
      .map((p) => ({
        ...p,
        selectNumber: p.cartInfo?.selected_number,
      }));
    const persist = keyBy(filteredPlans, "plan_code");
    const data = {
      result: {
        cartInfo: JSON.stringify({ persist }),
      },
    };
    await innerCart.loadData(data);
  } catch (e) {
    console.error(e);
  }
  return innerCart;
}

export default getPersistCart;
